import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { apisiseci } from "../../../../../api";
import { AxiosError } from "axios";
import { AttendanceLocalDepartmentGuicheService } from "../../../../../../@types/attendance-local-department-guiche-service";

export function useAttendanceLocalDepartmentGuicheServiceDelete(id: AttendanceLocalDepartmentGuicheService['id']) {
    const queryClient = useQueryClient();
    const token = localStorage.getItem("gov_access_token_sso");

    const mutation = useMutation({
        mutationKey: ["attendance-local", "department", "guiche", "service", "delete", id],
        mutationFn: async () => {
            const response = await apisiseci.delete<{ detail: string }>(
                `/cms/servicos_guiches/${id}/`,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            return response.data;
        },
        onSuccess: async () => {
            toast.success("Serviço do guichê excluído com sucesso!");

            await Promise.all([
                queryClient.invalidateQueries({
                    queryKey: ['attendance-local', 'department', 'guiche', 'service', 'list'],
                }),
                queryClient.invalidateQueries({
                    queryKey: ['attendance-local', 'service', 'list'],
                }),
            ]);
        },
        onError: (error: AxiosError<{ detail: string }>) => {
            toast.error(
                error?.response?.data.detail || "Algo deu errado, tente novamente!"
            );
            console.log(error);
        },
    });

    return mutation;
}
